module.exports = __webpack_public_path__ + "img/gpt-event-banner.7604597c.jpg";